import { Alert, Stack, Text } from '@mantine/core';
import { IconPhone } from '@tabler/icons-react';
import type { IntakeAction, IntakeAnswers } from '../types';
import { isHighRisk } from '../types';
import { StepBooking } from './StepBooking';

interface StepScreeningCallProps {
  answers: IntakeAnswers;
  dispatch: React.Dispatch<IntakeAction>;
}

export function StepScreeningCall({ answers, dispatch }: StepScreeningCallProps): JSX.Element {
  const highRisk = isHighRisk(answers);

  const alertBody = (() => {
    if (highRisk) {
      return 'Based on your responses, we\u2019d like to schedule a brief call with one of our intake coordinators to learn more about your needs and make sure we find the best fit for you.';
    }
    const screeningLabels = answers.therapyTypes
      .filter((t) => t === 'group' || t === 'iop')
      .map((t) => (t === 'iop' ? 'IOP' : 'Group'));
    const servicePhrase = screeningLabels.length > 0
      ? screeningLabels.join(' & ') + ' therapy'
      : 'the services you\u2019ve selected';
    return `Before we match you with a ${servicePhrase} provider, we\u2019d like to schedule a brief call with one of our intake coordinators to make sure it\u2019s the right fit for you.`;
  })();

  return (
    <Stack gap="md">
      <Alert variant="light" color="blue" icon={<IconPhone size={18} />}>
        <Text size="sm" fw={500}>
          {alertBody}
        </Text>
        <Text size="sm" c="dimmed" mt={4}>
          This is a 15-minute telehealth call. Your coordinator will walk you through next steps.
        </Text>
      </Alert>

      <StepBooking answers={answers} dispatch={dispatch} />
    </Stack>
  );
}
